import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { getTranslate } from "react-localize-redux";
import { actions } from "react-redux-form";
import { SearchPanel } from "../AppLayout/SearchPanel/SearchPanel";
import { fileActions } from "../../../redux/actions";
import { getFilesParams } from "../../../utils";
import { FilesGrid } from "./FilesGrid/FilesGrid";
import "./Files.scss";

class Files extends React.Component {
  handlePageClick = (event) => {
    event.preventDefault();
    var _pageNum = Number(event.target.id);
    if (_pageNum > 0) {
      this.props.dispatch(actions.change("fileSearch.PageNumber", _pageNum));
      this.props.dispatch(
        fileActions.getAll(
          getFilesParams(
            { ...this.props.fileSearch, PageNumber: _pageNum },
            this.props.isExternalUser,
            this.props.externalCustomerId
          ),
          `${this.props.translate("LoadingFiles")}...`
        )
      );
    }
  };
  handleFirstClick = (event) => {
    event.preventDefault();
    this.props.dispatch(actions.change("fileSearch.PageNumber", 1));
    this.props.dispatch(
      fileActions.getAll(
        getFilesParams(
          { ...this.props.fileSearch, PageNumber: 1 },
          this.props.isExternalUser,
          this.props.externalCustomerId
        ),
        `${this.props.translate("LoadingFiles")}...`
      )
    );
  };
  handleSearchClick = (event) => {
    if (event) event.preventDefault();
    const {
      dispatch,
      fileSearch,
      isExternalUser,
      externalCustomerId,
      location,
      history,
      translate,
    } = this.props;
    if (location.pathname !== "/files" || location.search) {
      history.push("/files");
    }

    dispatch(actions.change("fileSearch.PageNumber", 1));
    dispatch(
      fileActions.getAll(
        getFilesParams(
          { ...fileSearch, PageNumber: 1 },
          isExternalUser,
          externalCustomerId
        ),
        `${translate("LoadingFiles")}...`
      )
    ).then((data) => {
      if (data.files && data.files.length === 0) {
        dispatch(actions.change(`fileSearch.showMoreHeight`, "auto"));
        dispatch(actions.change(`fileSearch.moreArrowIcon`, "fa-chevron-up"));
        dispatch(
          actions.change(
            `fileSearch.toggleBtnTitle`,
            "Hide advanced search options"
          )
        );
      }
    });
  };

  handleParamChange = (paramName, paramValue) => {
    this.props.dispatch(actions.change(`fileSearch.${paramName}`, paramValue));
  };

  componentDidMount() {
    const {
      dispatch,
      translate,
      files,
      defaultSize,
      isExternalUser,
      externalCustomerId,
    } = this.props;
    let _searchQry = this.props.location.search;
    if (_searchQry) {
      var qs = require("qs");
      let queryObj = qs.parse(_searchQry.substr(1));
      if (
        queryObj["flowid"] &&
        queryObj["platform"] &&
        !files.cleared &&
        !files.error &&
        !files.loading &&
        !files.listFromFileLoaded
      ) {
        let params = {
          PageNumber: 1,
          Size: defaultSize || 20,
          FlowId: queryObj["flowid"],
          Platform: queryObj["platform"],
        };
        if (queryObj["sncts"]) {
          params["sncts"] = queryObj["sncts"];
        }
        dispatch(
          fileActions.getAllStartFilesDetails(
            params,
            `${translate("LoadingFiles")}...`
          )
        );
      }
      if (
        queryObj["fileId"] &&
        !files.cleared &&
        !files.error &&
        !files.loading &&
        !files.listFromFileLoaded
      ) {
        let params = {
          PageNumber: 1,
          Size: defaultSize || 20,
          FileId: queryObj["fileId"],
        };
        if (queryObj["sncts"]) {
          params["sncts"] = queryObj["sncts"];
        }
        if (queryObj["fidFs"]) {
          params["fidFs"] = queryObj["fidFs"];
        }

        // Force setting customerId for subuser if present in the url
        if (isExternalUser) {
          params["CustomerId"] = externalCustomerId;
        }
        if (queryObj["CustomerId"]) {
          params["CustomerId"] = queryObj["CustomerId"];

          if (
            !isExternalUser ||
            queryObj["CustomerId"] !== externalCustomerId
          ) {
            dispatch(
              actions.change("fileSearch.CustomerId", queryObj["CustomerId"])
            );
          }
        }
        dispatch(
          fileActions.getAllByFileId(params, `${translate("LoadingFiles")}...`)
        );
      }
    }
  }

  render() {
    const {
      files,
      fileSearch,
      translate,
      isExternalUser,
      externalCustomerId,
      defaultSize,
      handleShowTechnical,
    } = this.props;
    let PageNumber = 0;
    if (files.listFromFileLoaded) {
      PageNumber = files.params.PageNumber;
    } else {
      PageNumber = fileSearch.PageNumber;
    }
    let prev = PageNumber > 0 ? PageNumber - 1 : 0;
    let last = files.TotalPages;

    // Logic for displaying page numbers
    let pageNumbers = [];
    // get window of max 5
    let start = last > 4 ? last - 4 : 1;
    for (let i = start; i <= last; i++) {
      pageNumbers.push(i);
    }

    return (
      <div id="files_view">
        <div className="w-100 top_search" style={{ textAlign: "center" }}>
          <SearchPanel
            view="filesView"
            searchParams={fileSearch}
            isExternalUser={isExternalUser}
            externalCustomerId={externalCustomerId}
            handleParamChange={this.handleParamChange}
            onSearchClick={(params_) => {
              this.handleSearchClick(params_);
            }}
          />
        </div>
        <div
          id="files_content"
          className="content_block fill col-lg-12 col-md-12 col-sm-12 col-xs-12"
          style={{ padding: "0", width: "100%" }}
        >
          <div id="files_grids">
            {files.items && (
              <FilesGrid
                items={files.items}
                externalCustomerId={externalCustomerId}
                handleShowTechnical={handleShowTechnical}
                defaultSize={defaultSize}
              />
            )}
          </div>
          {files.items && files.items.length > 0 && (
            <div className="d-flex justify-content-center grid-footer">
              {/* <FormGroup className="mb-2 mr-sm-2 mb-sm-0 form-inline paging-count-select" /> */}
              <Pagination>
                <PaginationItem>
                  {prev === 0 ? (
                    <PaginationLink disabled>
                      <small>
                        <span className="fa fa-fast-backward" />
                      </small>
                      &nbsp;{translate("First")}
                    </PaginationLink>
                  ) : (
                    <PaginationLink
                      onClick={this.handleFirstClick}
                      id={prev}
                      href={prev}
                    >
                      <small>
                        <span className="fa fa-fast-backward" />
                      </small>
                      &nbsp;{translate("First")}
                    </PaginationLink>
                  )}
                </PaginationItem>
                <PaginationItem>
                  {prev === 0 ? (
                    <PaginationLink disabled>
                      <small>
                        <span className="fa fa-backward" />
                      </small>
                      &nbsp;{translate("Prev")}
                    </PaginationLink>
                  ) : (
                    <PaginationLink
                      onClick={this.handlePageClick}
                      id={prev}
                      href={prev}
                    >
                      <small>
                        <span className="fa fa-backward" />
                      </small>
                      &nbsp;{translate("Prev")}
                    </PaginationLink>
                  )}
                </PaginationItem>
                {pageNumbers.map((number, i) => (
                  <Pagination key={i}>
                    <PaginationItem
                      active={
                        pageNumbers.indexOf(PageNumber) === i ? true : false
                      }
                    >
                      <PaginationLink
                        onClick={this.handlePageClick}
                        href={number}
                        key={number}
                        id={number}
                      >
                        {number}
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                ))}

                <PaginationItem>
                  {PageNumber >= last ? (
                    <PaginationLink disabled>
                      {translate("Next")}&nbsp;
                      <small>
                        <span className="fa fa-forward" />
                      </small>
                    </PaginationLink>
                  ) : (
                    <PaginationLink
                      onClick={this.handlePageClick}
                      id={pageNumbers[pageNumbers.indexOf(PageNumber) + 1]}
                      href={pageNumbers[pageNumbers.indexOf(PageNumber) + 1]}
                    >
                      {translate("Next")}&nbsp;
                      <small>
                        <span className="fa fa-forward" />
                      </small>
                    </PaginationLink>
                  )}
                </PaginationItem>
              </Pagination>
              {/* <div className="grid-paging-info" style={{ margin: "0px 15px" }}>
                Version: {window.NTT && window.NTT.version}
              </div> */}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { files, fileSearch, locale } = state;
  return {
    files,
    fileSearch,
    translate: getTranslate(locale),
  };
}

const connectedFiles = connect(mapStateToProps)(withRouter(Files));
export { connectedFiles as Files };
